import { createReducer } from "@reduxjs/toolkit";
import moment from "moment-timezone";

const initStates = {
  userName: localStorage.getItem("username"),
  username: localStorage.getItem("useremail"),
  systemUid: localStorage.getItem("system_uid"),
  jobId: localStorage.getItem("job_id"),
  jobStatus: localStorage.getItem("ws_status"),
  jobType: localStorage.getItem("job_type"),
  postingHandleData: JSON.parse(localStorage.getItem("ig_linked_handles")),
  firebaseUid: localStorage.getItem("fbse_uid"),
  userTimezone: moment.tz.guess(),
  configFound: false,
};

const updateJobId = (state, action) => {
  state.jobId = action.payload;
};

const updateJobStatus = (state, action) => {
  state.jobStatus = action.payload;
};

const updateConfigFound = (state, action) => {
  state.configFound = action.payload;
};

const setFirebaseUID = (state, action) => {
  state.firebaseUid = action.payload;
}

export const reducer = createReducer(initStates, {
  updateJobId,
  updateConfigFound,
  updateJobStatus,
  setFirebaseUID
});
